import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
	DriverEnovaMapping,
	DriverIntegration,
	GratyfikantMapping,
	Organization,
} from '../_models/drivers-integration.model';

export interface GratyfikantPayload {
	organization_id: number;
	gratyfikant_id: string;
	date_from: string;
	date_to: string | null;
}

export interface EnovaPayload {
	enova_id: string;
	date_from: string;
	date_to: string | null;
}

@Injectable({ providedIn: 'root' })
export class DriversIntegrationApiService {
	private readonly http = inject(HttpClient);
	private readonly erpUrl = environment.erpSymfonyUrl;
	private readonly bagUrl = environment.apiUrl;

	getIntegration(driverId: string): Observable<{ data: DriverIntegration }> {
		return this.http.get<{ data: DriverIntegration }>(`${this.erpUrl}/driver/${driverId}/integration`);
	}

	saveIntegration(driverId: string, payload: DriverIntegration): Observable<DriverIntegration> {
		return this.http.put<DriverIntegration>(`${this.erpUrl}/driver/${driverId}/integration`, payload);
	}

	getGratyfikant(driverId: string): Observable<{ data: GratyfikantMapping[] }> {
		return this.http.get<{ data: GratyfikantMapping[] }>(
			`${this.erpUrl}/driver/${driverId}/integration/gratyfikant`,
		);
	}

	createGratyfikant(driverId: string, payload: GratyfikantPayload): Observable<GratyfikantMapping> {
		return this.http.post<GratyfikantMapping>(`${this.erpUrl}/driver/${driverId}/integration/gratyfikant`, payload);
	}

	updateGratyfikant(
		driverId: string,
		mappingId: string,
		payload: GratyfikantPayload,
	): Observable<GratyfikantMapping> {
		return this.http.put<GratyfikantMapping>(
			`${this.erpUrl}/driver/${driverId}/integration/gratyfikant/${mappingId}`,
			payload,
		);
	}

	deleteGratyfikant(driverId: string, mappingId: string): Observable<void> {
		return this.http.delete<void>(`${this.erpUrl}/driver/${driverId}/integration/gratyfikant/${mappingId}`);
	}

	getEnova(driverId: string): Observable<{ data: DriverEnovaMapping[] }> {
		return this.http.get<{ data: DriverEnovaMapping[] }>(`${this.erpUrl}/driver/${driverId}/integration/enova`);
	}

	createEnova(driverId: string, payload: EnovaPayload): Observable<{ data: DriverEnovaMapping }> {
		return this.http.post<{ data: DriverEnovaMapping }>(
			`${this.erpUrl}/driver/${driverId}/integration/enova`,
			payload,
		);
	}

	updateEnova(driverId: string, mappingId: number, payload: EnovaPayload): Observable<{ data: DriverEnovaMapping }> {
		return this.http.put<{ data: DriverEnovaMapping }>(
			`${this.erpUrl}/driver/${driverId}/integration/enova/${mappingId}`,
			payload,
		);
	}

	deleteEnova(driverId: string, mappingId: number): Observable<void> {
		return this.http.delete<void>(`${this.erpUrl}/driver/${driverId}/integration/enova/${mappingId}`);
	}

	getOrganizations(): Observable<{ results: Organization[] }> {
		return this.http.get<{ results: Organization[] }>(`${this.bagUrl}/organization/?is_oskar=true&limit=200`);
	}
}
